import html2pdf from "html2pdf.js";
import api from '../api/axios.js';

export const generatePdfBlob = async () => {
  const element = document.getElementById("offer-letter");
  
  const options = {
    margin: [10, 10, 10, 10],
    filename: 'offer-letter.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { 
      scale: 2,
      useCORS: true,
      allowTaint: true
    },
    jsPDF: { 
      unit: 'mm', 
      format: 'a4', 
      orientation: 'portrait'
    }
  };

  return await html2pdf()
    .from(element)
    .set(options)
    .outputPdf('blob');
};

export const generateAndUpload = async (data, advisor, positionType) => {
  try {
    const pdfBlob = await generatePdfBlob();

    const formData = new FormData();
    formData.append('file', pdfBlob, `offer-letter-${advisor._id}.pdf`);
    formData.append('advisorId', advisor._id);
    formData.append('positionType', positionType);
    formData.append('data', JSON.stringify(data));

    const response = await api.post('/admin/offer-letter/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error in generateAndUpload:', error);
    throw error;
  }
};


